// removed by extract-text-webpack-plugin
module.exports = {"footer":"_18w9HjjbDHLDBYNSV7oMN2","footerbuttons":"_2R2E58jGuG1hlTrwseS_gK"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/src/MessageBox/FooterLayout.scss
// module id = ./node_modules/wix-style-react/src/MessageBox/FooterLayout.scss
// module chunks = 0